import { Navigate } from 'react-router-dom';
import { isAuthor } from '@/lib/org-roles';
import {
  NewQuizForm,
  QuestionBankDetail,
  QuestionBankForm,
  QuestionBanks,
  QuestionEditor,
  QuizList,
} from '@/components/quiz/authoring';
import { PageHeader } from '@/components/ui';
import { useOrgContext } from './layout';

/** Authoring pages inside an organization; authors, admins and owners only. */
function useAuthorOrg() {
  const { org, role } = useOrgContext();
  return {
    allowed: isAuthor(role),
    owner: { kind: 'org' as const, orgId: org.id },
    base: `/organizations/${org.id}`,
  };
}

export function OrgQuizzesPage() {
  const { allowed, owner, base } = useAuthorOrg();
  if (!allowed) return <Navigate to=".." replace />;
  return <QuizList owner={owner} base={base} />;
}

export function OrgNewQuizPage() {
  const { allowed, owner, base } = useAuthorOrg();
  if (!allowed) return <Navigate to=".." replace />;
  return <NewQuizForm owner={owner} back={{ to: `${base}/quizzes`, label: 'Quizzes' }} />;
}

export function OrgQuestionBanksPage() {
  const { allowed, owner, base } = useAuthorOrg();
  if (!allowed) return <Navigate to=".." replace />;
  return (
    <>
      <PageHeader
        title="Question banks"
        description="Group questions by topic, technology or sector. Nirvik's library banks are available to reuse."
        back={{ to: `${base}/quizzes`, label: 'Quizzes' }}
      />
      <QuestionBanks owner={owner} base={base} />
    </>
  );
}

export function OrgQuestionBankFormPage() {
  const { allowed, owner, base } = useAuthorOrg();
  if (!allowed) return <Navigate to=".." replace />;
  return <QuestionBankForm owner={owner} base={base} />;
}

export function OrgQuestionBankPage() {
  const { allowed, owner, base } = useAuthorOrg();
  if (!allowed) return <Navigate to=".." replace />;
  return <QuestionBankDetail owner={owner} base={base} />;
}

export function OrgQuestionEditorPage() {
  const { allowed, base } = useAuthorOrg();
  if (!allowed) return <Navigate to=".." replace />;
  return <QuestionEditor base={base} />;
}
